import React from "react";
import styles from "../../volunteerRegistration/successComponent/success.module.scss";
import { useNavigate, useSearchParams } from "react-router-dom";

const PaymentSuccessComponent = () => {
  const navigate = useNavigate();
  const [searchParam] = useSearchParams();
  const receiptID = searchParam.get("receiptID");
  const userID = searchParam.get("userID");

  const onClickSuccessMessage = () => {
    navigate(`/receipt?receiptID=${receiptID}&userID=${userID}`);
  };

  const successSvg = (): React.ReactElement => {
    return (
      <>
        <div
          className={`${styles.icon} ${styles.icon_order_success} ${styles.svg}`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="154px" height="154px">
            <g fill="none" stroke="#22AE73" strokeWidth={2}>
              <circle
                cx={77}
                cy={77}
                r={72}
                style={{
                  strokeDasharray: "480px, 480px",
                  strokeDashoffset: "960px",
                }}
              />
              <circle
                id="colored"
                fill="#22AE73"
                cx={77}
                cy={77}
                r={72}
                style={{
                  strokeDasharray: "480px, 480px",
                  strokeDashoffset: "960px",
                }}
              />
              <polyline
                className="st0"
                stroke="#fff"
                strokeWidth={10}
                points="43.5,77.8 63.7,97.9 112.2,49.4 "
                style={{
                  strokeDasharray: "100px, 100px",
                  strokeDashoffset: "200px",
                }}
              />
            </g>
          </svg>
        </div>
        <br />
        <div
          style={{
            marginTop: "60px",
            marginBottom: "25px",
            textAlign: "center",
            fontSize: "xx-large",
          }}
        >
          <b>Payment Successfully Done !</b>
        </div>
        <div
          onClick={onClickSuccessMessage}
          style={{
            textAlign: "center",
            textDecoration: "underline",
            fontFamily: "Lato",
            color: "#f05802",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          Click here to Generate Receipt
        </div>
      </>
    );
  };

  return <div className={styles.animationCtn}>{successSvg()}</div>;
};

export default PaymentSuccessComponent;
